import api from "../../config/client.axios.api";

export const getAllRoleApiRequest = async () => {
  const response = await api.get(`/role`);
  return response.data;
};
